import { label } from "../UI/tokens";
import { FormCheck, FormGroup, FormLabel } from "react-bootstrap";
import styled from "styled-components";

export const LabelInput = styled(FormLabel)`
${label}
`;

export const FormGroupInput = styled(FormGroup)`
    margin-bottom: 1px;

margin-bottom: 14px; min-width: 0;
`;

export const CheckInput = styled(FormCheck)`
    display: inline-block;
    margin: 1vw;
`